export const isImage = (string: string) => /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(string.toLowerCase())
